import { SET_FETCHING } from "./constants";
import { ISetFetchingAction } from "./types";

/**
 * Nastaví indikátor načítání pro zadaný klíč.
 * @param key Klíč identifikuje, co se načítá.
 * @param isFetching Indikuje stav načítání. True pokud načítání probíhá, false pokud bylo dokončeno.
 */
export const createSetFetchingAction = (key: string, isFetching: boolean): ISetFetchingAction => ({
    type: SET_FETCHING,
    payload: {
        key,
        isFetching,
    },
});
